<template>
  <ContactUsComponent
    :is-visible="showContactModal"
    @close="closeContactModal"
  />
  <div class="wrapper-social-networks">
    <MenuComponent
      logoUrl="assets/logos/LogoViolet.svg"
      textColor="var(--violet)"
      menuIcon="assets/icons/MenuViolet.svg"
      closeIcon="assets/icons/CloseViolet.svg"
    />

    <PrincipalSection
      title="CREACIÓN DE CONTENIDO"
      text="Convertimos contenido en activos comerciales reales. Por eso hoy
          generamos <b>+90 %</b> en <b>visualizaciones</b> y hasta
          <b>19 M</b> de <b>reproducciones orgánicas</b> para nuestros clientes"
      overlayColor="var(--violet)"
      layout="media-left"
      mediaType="video"
      mediaSrc="assets/social-networks/InitialVideo.mp4"
      mediaAlt="Gestion redes sociales"
      buttonText="Agenda una llamada"
      buttonBackground="var(--white)"
      buttonTextColor="var(--violet)"
      buttonShadow="light"
      @button-click="openContactModal"
    />

    <div class="wrapper-info">
      <p class="title">GESTIÓN DE REDES</p>
      <p class="text">
        Convertimos datos, tendencias y comportamiento del consumidor en
        calendarios con el fin de:
      </p>
    </div>

    <div class="container">
      <div class="wrapper-content">
        <img
          src="assets/social-networks/Icon1.svg"
          alt="Sostener alcance"
          class="icon"
        />
        <p>Sostener alcance</p>
      </div>
      <div class="wrapper-content">
        <img
          src="assets/social-networks/Icon2.svg"
          alt="Acelerar crecimiento orgánico"
          class="icon"
        />
        <p>Acelerar crecimiento orgánico</p>
      </div>
      <div class="wrapper-content">
        <img
          src="assets/social-networks/Icon3.svg"
          alt="Multiplicar intención de compra"
          class="icon"
        />
        <p>Multiplicar intención de compra</p>
      </div>
    </div>

    <div class="mini-gallery">
      <img
        src="assets/social-networks/Image1.png"
        alt="Imagen redes sociales"
        class="image"
      />
      <img
        src="assets/social-networks/Image2.png"
        alt="Imagen redes sociales"
        class="image"
      />
      <img
        src="assets/social-networks/Image3.png"
        alt="Imagen redes sociales"
        class="image"
      />
    </div>

    <FooterComponent overlayColor="var(--violet)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import PrincipalSection from "../layout/components/PrincipalSection.vue";
import ContactUsComponent from "../sharedComponents/ContactUsComponent.vue";
import { contactUsUse } from "../sharedComponents/use/contactUsUse";

export default {
  name: "SocialNetworksView",
  components: {
    MenuComponent,
    FooterComponent,
    PrincipalSection,
    ContactUsComponent,
  },

  setup() {
    const { showContactModal, openContactModal, closeContactModal } =
      contactUsUse();

    return {
      showContactModal,
      openContactModal,
      closeContactModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/socialNetworks/styles/socialNetworksStyle";
</style>
